import React, { useState } from "react";
import { useDispatch } from "react-redux";

import * as actions from "../../actions";

import StandardTableHeader from "../UI/StandardHeader";

const Overview = () => {
  const [clicked, setClicked] = useState(false);
  const dispatch = useDispatch();

  const getOverview = async () => {
    setClicked(true);
    await dispatch(actions.getOverview());
    setClicked(false);
  };

  return (
    <div className="ui one column grid">
      <div className="column">
        <StandardTableHeader headerLabel="Overview" />
      </div>
      <div className="column">
        <button
          type="button"
          className="ui orange button "
          onClick={() => getOverview()}
          disabled={clicked}
        >
          Create Overview in CSV format.
        </button>
      </div>
    </div>
  );
};

export default Overview;
